const borders = {
  normal: '1px solid rgba(76, 76, 76, 0.4)',
  light: '1px solid rgba(76, 76, 76, 0.15)',
  normalWhite: '2px solid #D1D4DC',
  form: '1px solid #828282'
};

export { borders };
